import type { DependencyList } from 'react';
import { useCallback, useEffect, useState } from 'react';

function useRequest<T>(requestCallback: () => Promise<T>, deps: DependencyList): [T, boolean, any, () => void] {
  const [data, setData] = useState<T>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(undefined);

  // eslint-disable-next-line
  const cb = useCallback(requestCallback, deps);

  const requestData = useCallback(async () => {
    setData(undefined);
    setError(undefined);
    setIsLoading(true);
    try {
      const data = await cb();
      setData(data);
    } catch (e) {
      setError(e);
      setData(undefined);
    } finally {
      setIsLoading(false);
    }
  }, [cb]);

  useEffect(() => {
    requestData();
  }, [requestData]);

  return [data, isLoading, error, requestData];
}

export default useRequest;
